import { When } from '@teamsparta/react';
import { generateHTML, generateJSON } from '@tiptap/html';
import { useEditor } from '@tiptap/react';
import { useMemo } from 'react';

import { useIsClient } from '@/hooks';
import { sanitizeHtml } from '@/lib/utils/html';

import { EDITOR_EXTENSIONS } from './config';
import * as S from './style';

interface EditorContentProps {
  content: string;
}

/**
 * @description Tiptap의 EditorContent로도 렌더링할 수 있음.
 * 하지만 그럴 경우 서버 사이드에서 렌더링이 불가함.
 * 서버 사이드에서 렌더링하기 위해 다음과 같이 구현.
 *
 * @see https://tiptap.dev/docs/guides/output-json-html#render
 * @see https://tiptap.dev/docs/editor/api/utilities/html
 */
export function EditorContent({ content }: EditorContentProps) {
  // server
  const html = useMemo(() => {
    // 1. extensions이 적용된 함께 json 생성
    const json = generateJSON(content, EDITOR_EXTENSIONS);
    // 2. json을 html로 변환
    const generatedHTML = generateHTML(json, EDITOR_EXTENSIONS);
    // 3. 악성 스크립트 제거
    return sanitizeHtml(generatedHTML);
  }, [content]);

  // client
  const editor = useEditor({
    extensions: EDITOR_EXTENSIONS,
    content,
    editable: false,
    immediatelyRender: false,
  });
  const isClient = useIsClient();

  return (
    <When
      condition={isClient}
      fallback={
        <div
          className='tiptap'
          dangerouslySetInnerHTML={{ __html: html }}
          style={{ visibility: 'hidden' }}
        />
      }
    >
      <S.StyledEditor editor={editor} editable={false} />
    </When>
  );
}
